export default "__VITE_ASSET__Du1qtN49__"